import React from "react"
import classNames from "classnames"
import {makeStyles} from "@material-ui/core"

type DataParameterProps = {
    name: string
    value: number | string | null | undefined
    unit?: string
    unitSpace?: boolean
    className?: string
    upperCasedName?: boolean
    editable?: boolean
    param?: string
    isParameterEditing?: boolean
    onEdit?(param: string, value: string): void
}

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        minWidth: 100,
        "& span": {
            color: theme.palette.common.black,
            fontFamily: "Roboto",
            fontSize: 12,
        },
    },
    value_container: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
    },
    value_input: {
        border: 0,
        textAlign: "right",
        maxWidth: 50,
        fontSize: 14,
        borderBottom: "1px solid #eee",
    },
    upper_cased: {
        textTransform: "uppercase",
    },
}));

/**
 * @param props
 */
export default function DataParameter(props: DataParameterProps) {
    const styles = useStyles();
    const {
        name,
        value,
        unit,
        unitSpace = true,
        className,
        upperCasedName = false,
        editable = false,
        param,
        onEdit,
        isParameterEditing = false,
    } = props;

    const handleEdit = ({target: {value}}: React.ChangeEvent<HTMLInputElement>) => {
        if (onEdit && param && value.match(/^-?\d*\.?\d+$/)) {
            onEdit(param, value)
        }
    }

    function renderValue() {
        if (editable) {
            return (
                <div className={styles.value_container}>
                    <input
                        disabled={!isParameterEditing}
                        className={styles.value_input}
                        value={value === null || typeof value === "undefined" ? "" : value}
                        onChange={handleEdit}
                    />
                    <span>{renderUnit()}</span>
                </div>
            )
        }

        return (
            <span>{value}{renderUnit()}</span>
        )
    }

    function renderUnit() {
        if (typeof unit === "undefined") return null

        if (unitSpace) {
            return <span>&nbsp;{unit}</span>
        }

        return <span>{unit}</span>
    }

    return (
        <div className={classNames(styles.container, className)}>
            <span className={classNames({[styles.upper_cased]: upperCasedName})}>{name}:</span>
            {renderValue()}
        </div>
    )
}
